/* empty css                              */
import o from "./td-longtail-vue-components98.js";
const n = {
  name: "OfferTileList",
  props: {
    offers: {
      type: Array,
      required: !0
    },
    spaces: { type: Boolean }
  },
  computed: {
    offersWithProduct() {
      return this.offers.filter((r) => r?.product?.articleNumber) || [];
    },
    wrapperClass() {
      return {
        "offer-tiles--spaces": this.spaces
      };
    }
  }
};
var i = function() {
  var e = this, t = e._self._c;
  return e.offers.length > 0 ? t("div", { staticClass: "offer-tiles", class: e.wrapperClass }, [e._t("beforeOfferTiles"), e._t("offerTileContainer", function() {
    return [e._l(e.offersWithProduct, function(s, f) {
      return [e._t("default", null, { offer: s, index: f })];
    })];
  }), e._t("afterOfferTiles")], 2) : e._e();
}, a = [], l = /* @__PURE__ */ o(
  n,
  i,
  a,
  !1,
  null,
  "a30408d9"
);
const p = l.exports;
export {
  p as default
};
